import {Injectable} from "@angular/core";
import {SessionService} from "../../core/session.service";
import {Subject} from "rxjs/Subject";

@Injectable()
export class SidebarService {

    isVisible: boolean = false;
    config: any = {};
    private _sidebar: string = "";
    private sidebarSubject: Subject<string> = new Subject();

    constructor(private sessionServiceA2: SessionService) {
    }

    getIsVisible() {
        return this.sessionServiceA2.isVisibleSidebar();
    };

    getConfig() {
        return this.config;
    };

    get sidebar(): string {
        return this._sidebar;
    }

    set sidebar(section: string) {
        this._sidebar = section;
        this.sidebarSubject.next(section);
    }

    getSidebarSubject(): Subject<string> {
        return this.sidebarSubject;
    }

    enableButtons() {
        // -----------
        this.clearPermissions();
        // -----------
        if (this.sessionServiceA2.loggedUserAllowed('PERM_ADMIN_DATA_VIEW')) {
            this.config.showAdminData = true;
            this.config.showCompanyMenu = true;
        }
        if (this.sessionServiceA2.loggedUserAllowed('PERM_POS_VIEW')) {
            this.config.showBranches = true;
            this.config.showCompanyMenu = true;
        }
        if (this.sessionServiceA2.loggedUserAllowed('PERM_CONTRACT_VIEW')) {
            this.config.showContracts = true;
            this.config.showCompanyMenu = true;
        }
        if (this.sessionServiceA2.loggedUserAllowed('PERM_ALERT_VIEW')) {
            this.config.showAlertEmails = true;
            this.config.showCompanyMenu = true;
        }
        if (this.sessionServiceA2.loggedUserAllowed('PERM_PICKUP_POINT_VIEW')) {
            this.config.showPickupPoints = true;
            this.config.showCompanyMenu = true;
        }
        if (this.sessionServiceA2.loggedUserAllowed('PERM_HOLIDAY_VIEW')) {
            this.config.showHolidays = true;
            this.config.showCompanyMenu = true;
        }
        // -----------
        if (this.sessionServiceA2.loggedUserAllowed('PERM_FEE_VIEW')) {
            this.config.showFeesItem = true;
            this.config.showGeneralConditionsMenu = true;
        }
        if (this.sessionServiceA2.loggedUserAllowed('PERM_RANGE_DAYS_VIEW')) {
            this.config.showRangesItem = true;
            // config.showRangeDiscountsItem = true;
            this.config.showGeneralConditionsMenu = true;
        }
        if (this.sessionServiceA2.loggedUserAllowed('PERM_BOOKING_MODIFICATION_POLICY_VIEW')) {
            this.config.showBookingModificationPoliciesItem = true;
            this.config.showGeneralConditionsMenu = true;
        }
        if (this.sessionServiceA2.loggedUserAllowed('PERM_AGE_RANGE_VIEW')) {
            this.config.showAgeRangeItem = true;
            this.config.showGeneralConditionsMenu = true;
        }
        if (this.sessionServiceA2.loggedUserAllowed('PERM_RESTRICTIONS_VIEW')) {
            this.config.showRestrictionsItem = true;
            this.config.showGeneralConditionsMenu = true;
        }
        if (this.sessionServiceA2.loggedUserAllowed('PERM_ONEWAY_VIEW')) {
            this.config.showOneWayItem = true;
            this.config.showGeneralConditionsMenu = true;
        }
        if (this.sessionServiceA2.loggedUserAllowed('PERM_UPSELLING_VIEW')) {
            this.config.showAdditionalPricesItem = true;
            this.config.showInsurancePricesItem = true;
            this.config.showGeneralConditionsMenu = true;
        }
        // -------------
        if (this.sessionServiceA2.loggedUserAllowed('PERM_FLEET_VIEW')) {
            this.config.showFleetItem = true;
            this.config.showFleetMenu = true;
        }
        // -------------
        if (this.sessionServiceA2.loggedUserAllowed('PERM_AVAILABILITY_VIEW')) {
            this.config.showAvailabilityItem = true;
            this.config.showPricesAndAvailabilityMenu = true;
        }
        if (this.sessionServiceA2.loggedUserAllowed('PERM_PRICE_VIEW')) {
            this.config.showPricesItem = true;
            this.config.showPricesAndAvailabilityMenu = true;
        }
        if (this.sessionServiceA2.loggedUserAllowed('PERM_PRICE_AND_AVAILABILITY_VIEW')) {
            this.config.showPricesAndAvailabilityItem = true;
            this.config.showPricesAndAvailabilityMenu = true;
        }
        // -------------
        if (this.sessionServiceA2.loggedUserAllowed('PERM_BOOKING_VIEW')) {
            this.config.showBookingsItem = true;
            this.config.showBookingsMenu = true;
        }
        // -------------
        if (this.sessionServiceA2.loggedUserAllowed('PERM_ADMIN_DATA_CREATE')) {
            this.config.showNewCompanyItem = true;
        }
        // -------------
        if (this.sessionServiceA2.loggedUserAllowed('PERM_FLEET_LOAD')) {
            this.config.showFleetLoadItem = true;
        }
        // -------------
        if (this.sessionServiceA2.loggedUserAllowed('PERM_COMPANY_REQUEST_VIEW')) {
            this.config.showCompanyRequestItem = true;
        }
        // -------------
        if (this.sessionServiceA2.loggedUserAllowed('PERM_SPECIAL_OFFER_VIEW')) {
            this.config.showSpecialOffersItem = true;
        }
        //
        if (this.sessionServiceA2.loggedUserAllowed('PERM_SPECIAL_OFFER_MODERATE')) {
            this.config.showModerationMenu = true;
            this.config.showModerationItem = true;
        }
        //
        if (this.sessionServiceA2.loggedUserAllowed('PERM_MARKUP_VIEW')) {
            this.config.showMarkupMenu = true;
        }
        if (this.sessionServiceA2.loggedUserAllowed('PERM_REVIEW_VIEW')) {
            this.config.showReviewItem = true;
        }
        //
        if (this.sessionServiceA2.loggedUserAllowed('PERM_OPAQUE_RATE_VIEW')) {
            this.config.showOpaqueRateItem = true;
        }
        // TODO: crear permiso para ver pantalla de auditoría
        if (this.sessionServiceA2.loggedUserAllowed('PERM_AUDIT_VIEW')) {
            this.config.showAuditItem = true;
        }

    };

    clearPermissions() {
        this.config = {};
    };
}


// WEBPACK FOOTER //
// ./public/upgrade/root/sidebar/sidebar.service.ts